export default "__VITE_PUBLIC_ASSET__20d88bc7__"